// const ToggleContext = createContext<Signal<boolean>>(createSignal(false));
// /** 用于切换 */
// export function ToggleProvider (props: ParentProps<{value?: Signal<boolean>}>) {
//   return (
//     <ToggleContext.Provider value={props.value ?? createSignal(false)}>
//       {props.children}
//     </ToggleContext.Provider>
//   );
// }
// export function useToggle () {
//   return useContext(ToggleContext);
// }

export const BindContext = createContext<BindSingleContext | BindMultipleContext>();
/** 传递一个bind上下文，传入为空时将关闭此上下文 */
export function BindProvider(props: ParentProps<{ value: SignalLike<any> }>) {
  return <BindContext.Provider value={createBindContext(props.value)}>{props.children}</BindContext.Provider>;
}

function createBindContext<T>(bind: SignalLike<any>): BindSingleContext<T> {
  const [value, setValue] = bind;
  const [items, setItems] = createSignal(new Set<T>(), { equals: false });

  // const value = isList ? createMemo<Set<T>>((pre) => {
  //   pre.clear();
  //   (bind[0]() as T[]).forEach(it => pre.add(it));
  //   return pre;
  // }, new Set<T>(), {equals: false}): bind[0];

  return {
    get value() {
      return value();
    },
    get items() {
      return items();
    },
    addItem(item) {
      createComputed(() => {
        const value = item();
        setItems((pre) => {
          pre.add(value);
          return pre;
        });
        onCleanup(() => {
          setItems((pre) => {
            pre.delete(value);
            return pre;
          });
        });
      });
    },
    toggle(item) {
      setValue(item);
    },
  };
}

const bindMap = new WeakMap<Signal<any>, BindSingleContext<any>>();

export type ItemOf<T> = T extends (infer U)[] ? U : T;

export type SignalLike<T> = readonly [Accessor<T>, (value: NonNullable<T>) => void];
export function useBind<T extends readonly any[]>(bind?: SignalLike<T>): BindMultipleContext<ItemOf<T>>;
export function useBind<T = any>(bind?: SignalLike<any>): BindSingleContext<T>;
export function useBind(bind?: any): any {
  const ctx = useContext(BindContext);
  if (bind) {
    let cache = bindMap.get(bind);
    if (!cache) {
      cache = createBindContext(bind);
      bindMap.set(bind, cache);
    }
    return cache;
  } else if (!ctx) {
    throw new Error('No bind context!');
  }
  return ctx as any;
}

export interface BindSingleContext<T = any> {
  value: T;
  // valueSet: Set<T>;
  items: Set<T>;
  addItem(item: Accessor<T>): void;
  toggle(item: T): void;
}

interface BindMultipleContext<T = any> {
  value: T[];
  // valueSet: Set<T>;
  items: Set<T>;
  addItem(item: Accessor<T>): void;
  toggle(item: T[]): void;
}
